import { render, staticRenderFns } from "./ConfigExport.vue?vue&type=template&id=63ac81cf&scoped=true"
import script from "./ConfigExport.vue?vue&type=script&lang=js"
export * from "./ConfigExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ac81cf",
  null
  
)

export default component.exports